import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DashGraphConfigService from "../../../core/service/DashGraphConfigService";

const CreateGraphSetModal = ({ t, show, onClose, graphConfigIds = [], onSaved }) => {
  const [setName, setSetName] = useState("");
  const [validated, setValidated] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    setSetName("");
    setValidated(false);
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setValidated(true);
    if (!form.checkValidity()) return;

    setSaving(true);
    DashGraphConfigService.createGraphSet({ name: setName.trim(), graphConfigIds })
      .then((res) => {
        setSaving(false);
        if (res.status !== 200 && res.status !== 201 && res.status !== 204) return;

        toast.success("Success", { position: toast.POSITION.TOP_RIGHT });
        handleClose();
        if (onSaved) onSaved();
      })
      .catch(() => {
        setSaving(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{t("CreateSet.label")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="graphSetName">
            <Form.Label>{t("SetName.label")}</Form.Label>
            <Form.Control
              type="text"
              required
              value={setName}
              onChange={(e) => setSetName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {t("Save.label")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default withTranslation()(CreateGraphSetModal);
